package com.kinoshazam.uiKit.components.videoItem

import androidx.compose.foundation.clickable
import androidx.compose.foundation.hoverable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.image.ImageUiKitState
import com.kinoshazam.uiKit.components.image.UiKitImage
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.BoldMedium
import com.kinoshazam.uiKit.theme.UiKitTheme
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.movie
import models.Actor
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.jetbrains.compose.resources.painterResource

@OptIn(ExperimentalResourceApi::class)
@Composable
//TODO: remove Actor add CastState class
fun MovieCastItem(
    modifier: Modifier = Modifier,
    actor: Actor,
    onClick: (() -> Unit)? = null,
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isHovered by interactionSource.collectIsHoveredAsState()

    Column(
        modifier = modifier
            .hoverable(interactionSource)
            .then(
                if (onClick != null) Modifier.clickable(onClick = onClick) else Modifier
            ),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(space = 1.dp)
    ) {

        UiKitImage(
            modifier = Modifier.size(80.dp).clip(CircleShape),
            state = ImageUiKitState(
                contentDescription = "Cast",
                url = actor.profilePath,
                placeholder = painterResource(Res.drawable.movie),
                placeholderColor = UiKitTheme.colors.color_5,
                contentScale = ContentScale.Crop,
            ),
        )

        TextLabel(
            state = TextLabelState(
                text = actor.name ?: "Unknown actor",
                textStyle = BoldMedium,
                color = if (isHovered) UiKitTheme.colors.color_1 else UiKitTheme.colors.color_2,
                maxLines = 2,
                textAlign = TextAlign.Center
            ),
            modifier = Modifier.width(78.dp),
        )
    }
}
